import { apiGet } from '../../api'

export const get_all_tasks = () => {
  return apiGet({
    endpoint: `events/all_events`
  })
}
